import { cn } from "@monbits/ui";
import { Link, Outlet, useLocation } from "react-router-dom";

const TABS = [
	{ path: "/wallets/outbound", label: "Outbound" },
	{ path: "/wallets/inbound", label: "Inbound" },
	{ path: "/wallets/suspended", label: "Suspended" },
] as const;

export function WalletsLayout() {
	const location = useLocation();

	return (
		<div className="p-4 sm:p-6">
			<h1 className="text-3xl font-bold mb-6">Wallet Management</h1>

			<div className="flex items-center border-b mb-6">
				{TABS.map((tab) => {
					const isActive = location.pathname.startsWith(tab.path);

					return (
						<Link
							key={tab.path}
							to={tab.path + location.search}
							className={cn(
								"px-4 py-2 text-sm font-medium transition-colors border-b-2 -mb-px",
								isActive
									? "border-primary text-foreground"
									: "border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground",
							)}
						>
							{tab.label}
						</Link>
					);
				})}
			</div>

			<Outlet />
		</div>
	);
}
